import { render, staticRenderFns } from "./companychecktemplates.html?vue&type=template&id=7c0da0b0&"
import script from "./companychecktemplates.vue?vue&type=script&lang=js&"
export * from "./companychecktemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports